<template>
  <v-chip class="ma-2 chip_container bg-grey_1" variant="outlined" text-color="darkblue" color="darkblue">
    <template v-slot:prepend>
      <v-avatar class="text-primary-dark" v-if="item.supprime != '1' && item.transfere != '1'">
        <b>{{ item.quantite }}x</b>
      </v-avatar>
    </template>
    <div class="inner-chip" :class="[item.supprime == '1' || item.transfere == '1' ? 'text-decoration-line-through' : '']">
      {{ item.nom }} <span class="pl-1" v-if="item.information_variante_tarif"> - {{ item.information_variante_tarif }}</span>
    </div>
    <div v-if="item.supprime == '1'" class="ml-2 text-dark-red font-weight-bold text-button">Annulée</div>
    <div v-if="item.transfere == '1'" class="ml-2 text-dark-red font-weight-bold text-button">Transférée</div>
  </v-chip>
</template>

<script>
export default {
  props: ["item"],
};
</script>

<style lang="scss" scoped>
.inner-chip {
  white-space: normal;
}
.chip_container {
  height: auto;
}
</style>